import { CustomerType, PersonRole } from '../../models';
import { Distributors } from '../../types';
export const getCustomerPersonByRole = (customer, roles) => {
    var _a, _b;
    return (_b = (_a = customer === null || customer === void 0 ? void 0 : customer._embedded) === null || _a === void 0 ? void 0 : _a.persons) === null || _b === void 0 ? void 0 : _b.find((person) => {
        var _a;
        const roleName = (_a = person === null || person === void 0 ? void 0 : person.roles[0]) === null || _a === void 0 ? void 0 : _a.name;
        return roles.includes(roleName);
    });
};
export const getCustomerMainPerson = (customer) => getCustomerPersonByRole(customer, [PersonRole.AccountHolder, PersonRole.LegalRepresentative]);
export const getCustomerPartnerPerson = (customer) => getCustomerPersonByRole(customer, [PersonRole.TaxPartner]);
export const getPersonName = (person) => person ? `${person.firstName} ${person.lastName}` : '';
export const getCustomerName = (customer) => {
    const mainPerson = getCustomerMainPerson(customer);
    return getPersonName(mainPerson);
};
export const isBusinessCustomer = ({ type }) => type === CustomerType.BUSINESS;
export const isDistributorCustomer = (distributorId) => distributorId && !Object.values(Distributors).includes(distributorId);
//# sourceMappingURL=customerDetails.js.map